import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { AdminUser, CreateAdminUserPayload } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface CreateAdminUserResponse {
  response: {
    user: AdminUser
    errors?: string[]
  }
}

export const useCreateAdminUser = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  const mutation = useMutation<
    CreateAdminUserResponse,
    Error,
    { variables: any }
  >({
    mutationFn: async ({ variables }) => {
      const response = await fetchWithAuth(`${URL}/roles/create-admin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(variables),
      })

      // Transform backend response to frontend expected format
      return {
        response: {
          user: response.user,
          errors: response.error ? [response.error] : undefined,
        },
      }
    },
    onSuccess: () => {
      // Invalidate admin users list to refresh data
      queryClient.invalidateQueries({ queryKey: ['adminUsers'] })
    },
  })

  // Return in the format expected by existing code
  return [
    async (params: { variables: any }) => {
      return mutation.mutateAsync(params)
    },
    {
      loading: mutation.isPending,
      error: mutation.error,
    },
  ] as const
}
